import classNames from 'classnames';
import React, { forwardRef } from 'react';
export const TxRadio = forwardRef((props, ref) => {
    const { checked, label, name, required, value, onChange, onBlur, disabled, className = '', } = props;
    function onChangeInternal(e) {
        if (onChange) {
            onChange(e);
        }
    }
    function onBlurInternal(e) {
        if (onBlur) {
            onBlur(e);
        }
    }
    return (React.createElement("label", { className: classNames('tx-radio', className) },
        React.createElement("input", { type: "radio", checked: checked, className: "tx-radio__input", name: name, value: value, required: required, onChange: onChangeInternal, onBlur: onBlurInternal, "data-testid": name, disabled: disabled, ref: ref }),
        React.createElement("span", { className: "tx-radio__checkmark" }),
        React.createElement("span", { className: "tx-radio__label" }, label)));
});
//# sourceMappingURL=Radio.js.map